import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    title: String,
    serviceOrderId: Number,
    serviceCost: Object,
    disabled: Boolean,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getSuppliers()

    if (this.serviceCost) {
      this.currentServiceCost = this.serviceCost
      this.supplierId = this.serviceCost.supplierId
      this.currentServiceCost.costType =
        this.costTypes[this.serviceCost.costType]
      this.currentServiceCost.costValue = this.serviceCost.costValue
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    supplierLoading: false,
    firstValid: false,
    error: false,
    dialog: false,
    institutionId: null,
    supplierId: null,
    suppliers: [],
    currentServiceCost: {
      id: 0,
      costValue: '',
      costType: null,
      invoiceNumber: '',
      description: '',
    },
    costTypes: ['Custo material', 'Custo serviços'],
    costValueRules: [(v) => !!v || 'Valor custo é requerido'],
    invoiceNumberRules: [
      (v) => !!v || 'Nª da nota é requerido',
      (v) => v.length <= 20 || 'Nº da nota deve ter no máximo 20 caracteres',
    ],
    costTypeRules: [(v) => v != -1 || 'Tipo do custo é requerido'],
    descriptionRules: [(v) => !!v || 'Descrição é requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.close()
      }
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    async submit() {
      this.loading = true

      const serviceOrderCost = {
        Id: this.currentServiceCost.id,
        CostValue: this.currentServiceCost.costValue,
        CostType: this.costTypes.indexOf(this.currentServiceCost.costType),
        InvoiceNumber: this.currentServiceCost.invoiceNumber,
        SupplierId: this.supplierId,
        Description: this.currentServiceCost.description,
        ServiceOrderId: this.serviceOrderId,
      }

      let url = 'serviceOrderCost/add'

      if (this.isEditing) {
        url = 'serviceOrderCost/edit'
      }

      await this.apiService
        .post(url, serviceOrderCost)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },
}
